import React from 'react'

interface ITitleSection {
  title: string
  body?: string
  singleLine?: boolean
}

var parse = require('html-react-parser')

// Title can be maximum 7 words

const TitleSection = ({title, body, singleLine = true}:ITitleSection) => {
  return (
    <section className='__title-section'>
      <div className='container-xl'>
        <div className='__wrapper'>
          <h1>
            <span className='__c-gray'>{title.split(" ")[0]} </span>
            <span className='__c-green'>{title.split(" ")[1]} {singleLine ? "" : parse('<br/>')} </span>
            <span className={`${singleLine ? "__c-green" : "__c-gray"}`}>{title.split(" ")[2]} </span>
            <span className={`${singleLine ? "__c-gray" : "__c-green"}`}>{title.split(" ")[3]} </span>
            <span className={`${singleLine ? "__c-gray" : "__c-green"}`}>{title.split(" ")[4]} </span>
            <span className='__c-green'>{title.split(" ")[5]} </span>
            <span className='__c-green'>{title.split(" ")[6]} </span>
          </h1>
          <p className='mb-1'>{body}</p> 
        </div>
      </div>
    </section>
  )
}

export default TitleSection